import { SINGLE_API } from 'src/redux/actions/type';

export const getMaintenanceMode = (payload, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/maintenance-mode',
			beforeCallType: 'GET_MAINTENANCE_MODE_REQUEST',
			successType: 'GET_MAINTENANCE_MODE_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};

export const updateMaintenanceMode = (payload = {}, next, nextErr) => {
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'PUT' },
			uri: `/maintenance-mode`,
			params: { ...payload },
			beforeCallType: 'UPDATE_MAINTENANCE_MODE_REQUEST_REQUEST',
			successType: 'UPDATE_MAINTENANCE_MODE_REQUEST_SUCCESS',
			afterSuccess: next,
			afterError: nextErr
		}
	};
};
